import axios from "axios";
import { useEffect, useState } from "react";
import { errorNotify, successNotify } from "../../../Services/Notification.js";
import Breadcrumbs from "../../../components/ui/Breadcrumbs.jsx";
import TemplateBrokerConfig from "./TemplateBrokerConfig.jsx";
import TemplateBrokerHeader from "../../../components/backoffice/TemplateBroker/TemplateBrokerHeader.jsx";
import {
  actionPerm,
  actionPermissions,
} from "../../../components/authNavigation/AuthNavbar.jsx";
import AddTemplateBrokerMapping from "../../../components/backoffice/TemplateBroker/AddTemplateBrokerMapping.jsx";
import EditTemplateBrokerMapping from "../../../components/backoffice/TemplateBroker/EditTemplateBrokerMapping.jsx";
import DeleteTemplate from "../../../components/backoffice/TemplateBroker/DeleteTemplate.jsx";
import DeleteAlert from "../../../components/ui/DeleteAlert.jsx";
import useApiCall from "../../../utils/useApiCall.js";
import UpdateTemplateImage from "../../../components/backoffice/TemplateBroker/UpdateTemplateImage.jsx";

const apiUrl = `${process.env.REACT_APP_API_URL}api/template-broker`;
const getAllBroker = `${process.env.REACT_APP_API_URL}api/get-all-brokers`;

const TemplateBroker = () => {
  const [data, setData] = useState();
  const [filteredData, setFilteredData] = useState();
  const [filter, setFilter] = useState();
  const [loading, setLoading] = useState();
  const [buttonClicked, setButtonClicked] = useState();
  const [renderKey, setRenderKey] = useState(0);
  const [addTemplate, setAddTemplate] = useState();
  const [deleteTemplate, setDeleteTemplate] = useState();
  const [selectedItem, setSelectedItem] = useState();
  const [syncClicked, setSyncClicked] = useState([]);
  const headers = {
    Authorization: `Bearer ${
      sessionStorage.getItem("subscriberToken")
        ? sessionStorage.getItem("subscriberToken")
        : sessionStorage.getItem("token")
    }`,
    "Content-Type": "application/json",
  };

  const { data: brokerData, loading: brokerLoading } = useApiCall(
    getAllBroker,
    { headers },
  );

  const triggerRerender = () => {
    setRenderKey((prev) => prev + 1);
  };

  const getTemplateBroker = async () => {
    try {
      const res = await axios.get(apiUrl, { headers });
      if (!res.data.error) {
        setData(res.data.data?.sort((a, b) => b.template_id - a.template_id));
      } else {
        errorNotify(res.data.message);
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.err(err);
    }
  };

  useEffect(() => {
    setLoading(true);
    getTemplateBroker();
  }, [renderKey]);

  const unique = {};

  const uniqueData = data
    ?.filter((item) => {
      if (!unique[item.template_id]) {
        unique[item.template_id] = true;
        return true;
      }
      return false;
    })
    ?.sort((a, b) => b?.template_id - a?.template_id);

  const addTemplateBroker = async (data) => {
    try {
      const res = await axios.post(`${apiUrl}/`, data, { headers });
      if (res.data.error) {
        errorNotify(res.data.message);
      } else {
        successNotify(res.data.message);
        setAddTemplate();
        triggerRerender();
      }
    } catch (err) {
      errorNotify("Something went wrong");
    }
  };

  const updateTemplateBroker = async (data, id) => {
    try {
      const res = await axios.patch(
        `${apiUrl}/${selectedItem?.data?.broker_template_id}/`,
        data,
        { headers },
      );
      if (res.data.error) {
        errorNotify(res.data.message);
      } else {
        successNotify(res.data.message);
        setSelectedItem();
        triggerRerender();
      }
    } catch (err) {
      errorNotify("Something went wrong");
    }
  };

  const deleteTemplateBroker = async (data) => {
    try {
      console.log("data:::", data);
      const res = await axios.delete(
        `${apiUrl}/${data?.template_id || data?.broker_template_id}/`,
        { headers, data },
      );
      if (res.data.error) {
        errorNotify(res.data.message);
      } else {
        successNotify(res.data.message);
        setSelectedItem();
        triggerRerender();
      }
    } catch (err) {
      errorNotify("Something went wrong");
    }
  };

  const updateTemplateImage = async (templateId, image) => {
    const formData = new FormData();
    formData.append("template_id", templateId);
    formData.append("image", image);

    try {
      const res = await axios.post(
        `${apiUrl}/add_template_image/`,
        formData,
        { headers: { Authorization: headers.Authorization } },
      );
      if (res.data.error) {
        errorNotify(res.data.message);
        return false;
      }

      successNotify(res.data.message);
      setSelectedItem();
      triggerRerender();
      return true;
    } catch (err) {
      errorNotify("Something went wrong");
      return false;
    }
  };

  const handleSyncData = async (id, type) => {
    setSyncClicked((prev) => [...prev, data]);
    const filterOut = syncClicked?.filter((item) => item === type);
    try {
      const res = await axios.post(
        `${apiUrl}/sync_template_to_instance/`,
        { refresh_upto_id: id, sync_data_to: type },
        { headers },
      );

      if (res.data.error) {
        setSyncClicked(filterOut);
        errorNotify(res.data.message);
      } else {
        setSyncClicked(filterOut);
        successNotify(res.data.message);
        setSelectedItem();
        triggerRerender();
        return true;
      }
    } catch (err) {
      setSyncClicked(filterOut);
      errorNotify("Something went wrong");
      return true;
    }
  };

  useEffect(() => {
    let filtered = data;
    if (filter?.template_id) {
      filtered = filtered?.filter(
        (item) => item.template_id === filter?.template_id,
      );
    }
    if (filter?.broker_id) {
      filtered = filtered?.filter(
        (item) => item.broker_id === filter?.broker_id,
      );
    }
    setFilteredData(filtered);
  }, [data, filter]);

  const breadcrumbs = ["Home", "Back Office", "Template Mapping"];

  const buttonConfig = {
    addHandler: addTemplateBroker,
    editHandler: updateTemplateBroker,
    deleteHandler: deleteTemplateBroker,
    handleSyncData: handleSyncData,
    closePopup: () => {
      setSelectedItem();
      setAddTemplate();
      setDeleteTemplate();
    },
  };

  const actionPermission = actionPermissions(
    "back office",
    "Access & Permissions",
  );

  const action = actionPerm(actionPermission);

  return (
    <div className=" app-container min-h-[65vh] pb-[60px] pt-[100px]">
      <Breadcrumbs items={breadcrumbs} />
      <TemplateBrokerHeader
        isLoading={loading}
        data={data}
        setFilter={setFilter}
      />
      <TemplateBrokerConfig
        tableData={filteredData}
        buttonConfig={buttonConfig}
        loading={loading}
        actionPermissions={actionPermission}
        setDeleteTemplate={setDeleteTemplate}
        setSelectedItem={setSelectedItem}
        setAddTemplate={setAddTemplate}
        action={action}
        syncClicked={syncClicked}
      />
      {addTemplate && (
        <AddTemplateBrokerMapping
          data={data}
          buttonConfig={buttonConfig}
          buttonClicked={buttonClicked}
          brokerData={brokerData}
          brokerLoading={brokerLoading}
        />
      )}
      {selectedItem?.type === "edit" && (
        <EditTemplateBrokerMapping
          data={selectedItem?.data}
          buttonConfig={buttonConfig}
          buttonClicked={buttonClicked}
          brokerData={brokerData}
          brokerLoading={brokerLoading}
        />
      )}
      {selectedItem?.type === "delete" && (
        <DeleteAlert
          id={selectedItem?.data}
          deleteHandler={deleteTemplateBroker}
          closeHandler={setSelectedItem}
        />
      )}
      {selectedItem?.type === "update-image" && (
        <UpdateTemplateImage
          data={selectedItem?.data}
          updateHandler={updateTemplateImage}
          closeHandler={() => setSelectedItem()}
        />
      )}
      {deleteTemplate && (
        <DeleteTemplate
          data={uniqueData}
          buttonConfig={buttonConfig}
          buttonClicked={buttonClicked}
          action={action}
        />
      )}
    </div>
  );
};

export default TemplateBroker;
